export const GET_ORG_NPS_SETTINGS = 'GET_ORG_NPS_SETTINGS';
export const UPDATE_NPS_SETTINGS = 'UPDATE_NPS_SETTINGS';
export const GET_EMPLOYEE_NPS_DECLARATION = 'GET_EMPLOYEE_NPS_DECLARATION';
export const UPDATE_EMPLOYEE_NPS_DECLARATION = 'UPDATE_EMPLOYEE_NPS_DECLARATION';
export const FETCH_TAX_AND_SALARY_ESTIMATE = 'FETCH_TAX_AND_SALARY_ESTIMATE';
